import clsx from 'clsx';
import styles from './DialogFooter.module.scss';
import React from 'react';
export function DialogFooter({ className, children }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.footer, className)
    }, children);
}
